import React, { useReducer } from 'react';
import { BreadCrumb, FooterSection } from '../components';
import './../../styles/irctcForgotPasswordPage.css';
import './../../styles/UpdateCenterCommon.css';
import './../../styles/base.css';
import SimilarQuestions from '../components/SimilarQuestions';
import IrctcFaq from '../components/IrctcFaq';
import AboutInfo from './components/AboutInfo';
import CapchaInfo from './components/CapchaInfo';
import WrongCredentialsInfo from './components/WrongCredentialsInfo';
import {
  ABOUT_IRCTC_DESRIPTION,
  ABOUT_IRCTC_TITLE,
  CAPCHA_INFO_TITLE,
  FOOTER_DATA_IRCTC,
  IRCTC_BREAD_CRUMB_COMMON,
  IRCTC_EXTERNAL_JS,
  IRCTC_FAQ_TITLE,
  SIMILAR_QUESTIONS_TITLE,
  WRONG_CREDENTIALS_TITLE
} from '../../utils/RailsSEOConstants';
import { FirstBookingPersuation } from '../components/FirstBookingPersuation';
import { getStaticPageLoadEvent } from '../../utils/omnitureUtils';
import HtmlHeader from '../components/HtmlHeader';
import AdWrapper from '../components/AdWrapper';
import { AD_PAGES } from '../../utils/adsUtils';
import PropTypes from 'prop-types';
import { searchWidgetInitialState, searchWidgetReducer } from '../../reducers/searchWidgetReducer';
import SearchWidget from '../components/SearchWidget/SearchWidget';
import { TrainClasses } from '../route_info/TrainClasses';
import { isMobile } from '../../utils/commonUtils';

const SearchWidgetContext = React.createContext<any>(searchWidgetInitialState);
const IrctcLoginPage = (props) => {
  const [searchWidgetState, searchWidgetDispatch] = useReducer(searchWidgetReducer, searchWidgetInitialState);
  const { data } = props;
  const isMobileDevice = isMobile();
  const {
    template: { h1_title: IRCTC_LOGIN_TITLE }
  } = data;
  return (
    <React.Fragment>
      <HtmlHeader data={data} />
      <SearchWidgetContext.Provider value={{ searchWidgetState, searchWidgetDispatch }}>
        <SearchWidget
          openDatePickerOnMount={false}
          topFix={true}
          classNode={TrainClasses.FC}
          pageWiseContext={SearchWidgetContext}
        />
      </SearchWidgetContext.Provider>
      <main className="container irctcLogin">
        <div className={`append_bottom30 appendTop30`}>
          <AdWrapper adsPageName={AD_PAGES.IRCTC_LOGIN_PAGE.adsPageName} />
        </div>
        <div className="appendBottom20">
          <BreadCrumb breadcrumb={data.template.breadcrumb} noLeftPadding />
        </div>
        <h1 className={'appendBottom20 font24'}>{IRCTC_LOGIN_TITLE}</h1>
        <h2>{ABOUT_IRCTC_TITLE}</h2>
        <p
          className={`font16 lineHeight24 ${
            isMobileDevice ? 'appendBottom30 blackText latoSemiBold' : 'appendBottom40'
          }`}
        >
          {ABOUT_IRCTC_DESRIPTION}
        </p>
        <AboutInfo customClass="appendBottom40" />
        <div id="capcha" className="adjustScrollPosition">
          <h2>{CAPCHA_INFO_TITLE}</h2>
          <CapchaInfo customClass="appendBottom40" />
        </div>

        <div id="wrongCredentials" className="adjustScrollPosition">
          <h2>{WRONG_CREDENTIALS_TITLE}</h2>
          <WrongCredentialsInfo customClass="appendBottom40" />
        </div>
        <FirstBookingPersuation />
        <h2>{SIMILAR_QUESTIONS_TITLE}</h2>
        <SimilarQuestions customClass="appendBottom40" />
        <h2>{IRCTC_FAQ_TITLE}</h2>
        <IrctcFaq customClass="appendBottom40" />
      </main>
      <FooterSection template={data.template} />
    </React.Fragment>
  );
};

IrctcLoginPage.propTypes = {
  data: PropTypes.object
};
IrctcLoginPage.fetchData = async (_, match, urlObj) => {
  const template = {
    template_name: `irctc-login`,
    meta_title: `IRCTC Login, Do IRCTC Signup for IRCTC Registration on MakeMyTrip`,
    meta_description: `Create IRCTC login account. MakeMyTrip offers quick and easy way to do IRCTC registration. Find all info about IRCTC signup process on MakeMyTrip.`,
    meta_keywords: `irctc login, irctc login id, irctc registration, irctc login new, irctc sign up`,
    analytics: getStaticPageLoadEvent('seo:rails:irctclogin'),
    footer_data: FOOTER_DATA_IRCTC,
    h1_title: `IRCTC Login`,
    breadcrumb: [...IRCTC_BREAD_CRUMB_COMMON],
    banner_desktop: ``,
    banner_mobile: ``,
    sample_url: `https://www.makemytrip.com/railways/irctc-login.html`,
    external_js: IRCTC_EXTERNAL_JS,
    extra_info: ``
  };

  const finalResponse = {
    template
  };
  const pageType = 'trains';
  const cacheKey = 'HTML_STATIC_IRCTC-LOGIN.HTML';
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    pageType,
    ...finalResponse
  };
};

export default IrctcLoginPage;
